/**
 * @generated SignedSource<<9ab9d04f3e09a3832a6bf85f7dd9c03e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoField_User$data = {
  readonly video: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "VideoField_User";
};
export type VideoField_User$key = {
  readonly " $data"?: VideoField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Video",
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "21ca0bb68d978dd7c3846a88b9a59adc";

export default node;
